

 export const GlobalName:any ={
    tokenName:"saeToken",
    currentRoleIndex:"saeRoleIndex",
    refreshTokenName:"saeRefreshToken",
    userName:"saeUserConnected",
    childName:"saeChildSelected",
    exercice:"saeExercise",
    expireIn:'saeExpireIn',
    features:'saeFeatures'
 }
